// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/checkbox-group","root":"checkbox-group-m__root__2iA5u","legend":"checkbox-group-m__legend__2fbir"};